module.exports = __webpack_public_path__ + "img/login-background.8136680.jpeg";